export default __webpack_public_path__ + "static/media/Facebook.44a0c086.svg";